export const ANALYTICS_CHANNEL = 'navigation';
export const ANALYTICS_TAG = 'navigationExperiences';
export const NAV_LAYER = 'global';
export const NAV_CONTAINER = 'top';
export const NAV_VERSION = 4;
export const ANALYTICS_SOURCE = 'topNav';
export const ATI_PRESETS = {
	PAGE: 'ati:cloud:confluence:page',
	WHITEBOARD: 'ati:cloud:confluence:whiteboard',
	GOAL: 'ati:cloud:townsquare:goal',
	WORK_ITEM: 'ati:cloud:jira:issue',
	LOOM: 'ati:cloud:loom:video',
	PROJECT: 'ati:cloud:townsquare:project',
	TEAM: 'ati:cloud:townsquare:team',
	TRELLO_BOARD: 'ati:cloud:trello:board',
};

/**
 * @deprecated Use ATI_PRESETS.LOOM instead.
 */
export const LOOM_ATI: string = ATI_PRESETS.LOOM;
